module.exports = __webpack_public_path__ + "static/img/pickup-doublecab-blue.c2e521c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-doublecab-blue.svg
// module id = wfxL
// module chunks = 74